export default "__VITE_ASSET__B1qSx7g$__"